"use client";

import { StandardProps } from "../../componentMap";
import { useVariant } from "../../../hooks/useVariant/useVariant";
import { isAvailableToOrder } from "../../../utils/product/isAvailableToOrder";
import { GridGalleryUI } from "./GridGalleryUI";
import { GalleryContextProvider } from "./GridGalleryContext";
import { ConfigProps } from "../../../types/types";

export type Options = {
  featureFlags?: {
    showClickToZoom?: boolean | string | number;
    showClickToZoomMobile?: boolean | string | number;
  };
};

type GalleryProps = Pick<
  StandardProps,
  "product" | "configProps" | "experiences"
> & {
  options?: Options;
  sizes: string;
  configProps?: ConfigProps & {
    SocialProofMessages?: {
      appId: string;
      withClose?: boolean;
    };
  };
};

export const GridGallery = ({ product, sizes, configProps }: GalleryProps) => {
  const { variant } = useVariant(product);

  if (!variant) return null;

  const media = "media" in product ? product.media : null;

  const videos = media?.videos || [];

  const title = variant.title;

  const images = variant.images;

  const socialProofMessagesProperties =
    product.__typename === "SimpleProduct" && configProps?.SocialProofMessages
      ? {
          ...configProps.SocialProofMessages,
          productId: product.aliases.pimProductId,
          brand: product.brand.name,
          availableToOrder: isAvailableToOrder(product),
        }
      : undefined;

  return (
    <GalleryContextProvider
      product={product}
      enableAnalytics={configProps?.enableAnalytics ? true : false}
      selectedVariant={variant}
    >
      <GridGalleryUI
        title={title}
        images={images}
        videos={videos}
        sizes={sizes}
        hasSocialProofMessagesExperience={true}
        socialProofMessagesProperties={socialProofMessagesProperties}
      />
    </GalleryContextProvider>
  );
};
